import React, { useState, useEffect, useContext } from "react";

import MainPagination from "../common/MainPagination";
import MainButton from "../common/MainButton";
import MainTitle from "../common/MainTitle";

import { YearContext } from "../../contexts/yearContext";

import DataTable from "./StudentsList";
import Filter from "./StudentsFilter";

import lbl from "../../data/Labels.json";
import db from "../../services/query";

import _ from "lodash";
import {PopUpContext} from "../../contexts/popUpContext";
import ToggleButton from "./ToggleButtom";

const Students = () => {
  // here are some commented code. because we are testing different UIs
  const [data, setData] = useState([]);
  const [allStudents, setAllStudents] = useState(false); // to switch between 'active' and 'all students'
  // const [stateId, setStateId] = useState(-1); // to switch between 'active' and 'all students'
  const { entryYear } = useContext(YearContext);
  const { togglePopUp, popUp } = useContext(PopUpContext);

  useEffect(() => {
    const ac = new AbortController();

    requestData(allStudents ? {} : {entry_year_id: entryYear});
    // requestData(stateId >= 0 ? {student_status_id: stateId > 0 ? stateId : undefined} : {entry_year_id: entryYear});

    return () => ac.abort();
  }, [entryYear, allStudents]);
  // }, [entryYear, stateId]);

  const requestData = async (p = {}) => {
    try {
      let {
        keyword: student_name,
        student_father_name,
        student_phone,
        entry_year_id,
        department_id,
        faculty_id,
        aria_id,
        enrolled,
        gender_id,
        page,
        student_status_id,
      } = p;

      let query = "students?";

      if (allStudents) query += `&all_students=${true}`;
      // if (stateId >= 0) query += `&all_students=${true}`;
      if (student_name) query += `&student_name=${student_name}`;
      if (page) query += `&page=${page}`;
      if (student_father_name)  query += `&student_father_name=${student_father_name}`;
      if (student_phone) query += `&student_phone=${student_phone}`;
      if (gender_id) query += `&gender_id=${gender_id}`;
      if (faculty_id) query += `&faculty_id=${faculty_id}`;
      if (department_id) query += `&department_id=${department_id}`;
      if (entry_year_id) {
        if (allStudents) {
        // if (stateId >= 0) {
          query += `&entry_year_id=${entry_year_id}`;
        } else {
          // TODO: this can be changed?
          // pass 0 to list not enrolled students
          entry_year_id = enrolled === "not-enrolled" ? 0 : entry_year_id
          query += `&entry_year_id=${entry_year_id}`;
        }
      }
      if (aria_id) query += `&aria_id=${aria_id}`;
      if (student_status_id) query += `&student_status_id=${student_status_id}`;
      // if (student_status_id || stateId > 0) query += `&student_status_id=${student_status_id || stateId}`;

      await db.getAll(query).then(({ data }) => {
        setData(data);
      });
    } catch ({ response }) {
      setData(response);
    }
  };

  return (
    <div className="main-content">
      <div className="main-content-header">
        <div className="right-content">
          <MainTitle title={lbl.StudentsList} />
        </div>
        <div className="center-content">
          <Filter query={requestData} hasFilter={true} allStudents={allStudents}/>
          {/*<Filter query={requestData} hasFilter={true} allStudents={stateId >= 0} />*/}
        </div>
        <div className="left-content">
          <MainButton
              type="add"
              title={lbl.AddStudent}
              handleClick={() => togglePopUp({ form: "student-form" })}
          />
          <ToggleButton allStudents={allStudents} setAllStudents={setAllStudents} />
          {/*<StudentStatusDropDown setStateId={setStateId} />*/}
        </div>
      </div>
      <div className="main-content-body pagination">
        <DataTable data={data?.data} allStudents={allStudents}/>
        {/*<DataTable data={data?.data} allStudents={stateId >= 0}/>*/}
      </div>
      <div className="main-content-footer">
        <div className="route-history-area"></div>
        <div className="pagination-area">
          <MainPagination gotoPage={requestData} data={data} forceEntryYear={!allStudents}/>
          {/*<MainPagination gotoPage={requestData} data={data} forceEntryYear={stateId >= 0}/>*/}
        </div>
      </div>
    </div>
  );
};

export default Students;
